/* eslint-disable @typescript-eslint/no-empty-object-type */
import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

import { GRPC_ENVIRONMENT } from './environment.provider';

type GrpcConstructor<T = {}> = new (address: string, ...args: Array<any>) => T;

export function CommonGrpcContractFactory<T>(GrpcContractClient: GrpcConstructor<T>, isMainApidomain: boolean = false) {
  return () => {
    const environment = inject(GRPC_ENVIRONMENT);
    const platformId = inject(PLATFORM_ID);
    let domain: string = environment.domain as string;
    const mainApidomain: string = environment.mainApidomain as string;
    if (isPlatformBrowser(platformId)) {
      const markDomain = sessionStorage.getItem('mark-domain');
      if (isMainApidomain) {
        domain = mainApidomain;
      }
      if (markDomain) {
        domain = markDomain;
      }
    } else {
      if (isMainApidomain) {
        domain = mainApidomain;
      }
    }
    return new GrpcContractClient(domain);
  };
}
